<template>
  <div :class="`rn-accordion-style ${accordionStyleClass} accordion`">
    <div class="accordion" :id="id">
      <div class="accordion-item card" v-for="content in accordionContent" :key="content.id">
        <h2 class="accordion-header card-header" :id="`heading${content.id}`">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
            :data-bs-target="`#collapse${content.id}`" aria-expanded="false"
            :aria-controls="`collapse${content.id}`">
            {{ content.title }}
            <i class="collapse-icon" aria-hidden="true" />
          </button>
        </h2>
        <div :id="`collapse${content.id}`" class="accordion-collapse collapse"
          :aria-labelledby="`heading${content.id}`" :data-bs-parent="`#${id}`">
          <div class="accordion-body card-body">
            {{ content.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    id: {
      type: String,
      default: 'accordionExample'
    },
    accordionStyleClass: {
      type: String
    },
    accordionContent: {
      type: Array,
      default: function () {
        return [
          {
            id: 'One',
            title: 'Are there tangible benefits to implementing EV roaming?',
            description:
              'Indeed, there are significant advantages, especially in countries with high charger utilization rates. EV roaming enhances your platforms user engagement, which can be leveraged for future marketing initiatives.'
          },
          {
            id: 'Two',
            title: 'How is the choice made between peer-to-peer and hub-based topology?',
            description:
              'The hub-based architecture has demonstrated its effectiveness, particularly when multiple operators are part of the community. This becomes even more advantageous when international integration among various country hubs is achieved.'
          },
          {
            id: 'Three',
            title: 'Will this service help reduce development costs?',
            description:
              'Absolutely, it not only reduces development costs but also accelerates time to market. Managing peer-to-peer connections for all connected operators can be labor-intensive and require extensive maintenance.'
          },
          {
            id: 'Four',
            title: 'Are there any supplementary services available?',
            description:
              'Certainly, we offer a range of valuable services and tools that can be seamlessly integrated with your existing platform. These include real-time database access, customized authorization solutions, data analytics, and more. Please dont hesitate to reach out to our team for further information on these offerings.'
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.rn-accordion-style.accordion-white .card {
  background: #ffffff !important;
  border: 1px solid #eeeeee !important;
}

.rn-accordion-style.accordion-white .card .card-header button {
  color: #181818 !important;
}

.rn-accordion-style.accordion-white .card .card-body {
  color: #65676b !important;
  border-top: 1px solid #eeeeee !important;
}

.rn-accordion-style.accordion-white .card .card-header button .collapse-icon:before,
.rn-accordion-style.accordion-white .card .card-header button .collapse-icon:after {
  background-color: #181818 !important;
}
</style>
